"use client"

import { useSession } from "next-auth/react"
import { Button } from "@/components/ui/button"
import { stopImpersonation } from "@/lib/actions/admin-actions"
import { LogOut, UserCheck } from "lucide-react"
import { useTransition } from "react"
import { toast } from "sonner"

export function ImpersonationBanner() {
  const { data: session, status } = useSession()
  const [isPending, startTransition] = useTransition()

  if (status === "loading" || !session?.user.isImpersonating) {
    return null
  }

  const handleStopImpersonation = () => {
    startTransition(async () => {
      try {
        await stopImpersonation()
        // Redirect will happen via server action
        // toast.success("Stopped impersonating. You are now back to your admin account.");
      } catch (error: any) {
        toast.error(error.message || "Failed to stop impersonation.")
      }
    })
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-yellow-400 p-1 text-yellow-900 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <UserCheck className="mr-2 h-5 w-5" />
          <p className="text-sm font-medium">
            You are currently impersonating <span className="font-bold">{session.user.name || session.user.email}</span>
            .
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleStopImpersonation}
          disabled={isPending}
          className="hover:bg-yellow-500 text-yellow-900 hover:text-yellow-900"
        >
          <LogOut className="mr-2 h-4 w-4" />
          {isPending ? "Reverting..." : "Stop Impersonating"}
        </Button>
      </div>
    </div>
  )
}
